import { fetchWithAuth } from './auth';

export interface AppraisalSummary {
  id: string;
  policyholder_name: string | null;
  claim_number: string | null;
  property_address: string | null;
  address_street: string | null;
  address_city: string | null;
  address_state: string | null;
  status: string | null;
  created_at: string;
}

export async function listAppraisals(): Promise<AppraisalSummary[]> {
  const r = await fetchWithAuth('/api/appraisals');
  if (!r.ok) throw new Error(`listAppraisals failed: ${r.status}`);
  return (await r.json()) as AppraisalSummary[];
}

export interface CreateSessionArgs {
  job_id: string;
  mode: 'new' | 'reinspection';
  reinspection_type?: 'new_set' | 'add_to_existing';
  gap_preserved?: boolean;
}

export interface CreatedSession {
  id: string;
  started_at: string;
}

export interface InspectionSessionRow {
  id: string;
  org_id: string;
  job_id: string;
  user_id: string;
  mode: string;
  reinspection_type: string | null;
  gap_preserved: boolean;
  started_at: string | null;
  completed_at: string | null;
  synced_at: string | null;
}

export async function createSession(args: CreateSessionArgs): Promise<CreatedSession> {
  const r = await fetchWithAuth('/api/field/sessions', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(args),
  });
  if (!r.ok) throw new Error(`createSession failed: ${r.status}: ${await r.text()}`);
  return (await r.json()) as CreatedSession;
}

export async function getSession(id: string): Promise<InspectionSessionRow> {
  const r = await fetchWithAuth(`/api/field/sessions/${id}`);
  if (!r.ok) throw new Error(`getSession failed: ${r.status}`);
  return (await r.json()) as InspectionSessionRow;
}

export interface CompleteJobResult {
  ok: true;
  job_id: string;
  completed_at: string;
  synced_count: number;
}

export async function completeJob(jobId: string): Promise<CompleteJobResult> {
  const r = await fetchWithAuth('/api/field/sessions/complete-job', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ job_id: jobId }),
  });
  if (!r.ok) {
    throw new Error(`completeJob: ${r.status}: ${(await r.text()).slice(0, 200)}`);
  }
  return (await r.json()) as CompleteJobResult;
}
